import styled from 'styled-components';
// note #matchNavbarHeight
const navbarHeight = '9rem';

const HelveticaFontFamily = `
  font-family: Helvetica;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  // line-height: 1;
`;

const InputBlackStyles = `
${HelveticaFontFamily}
  background-color: rgba(255, 255, 255, 0.2) !important;
  border: none !important;
  color: white !important;
  font-size: 12px !important
  letter-spacing: -0.2px;
  color: #ffffff;
  padding: 1rem !important;

  &::placeholder {
    color: #b5b5b5 !important;
  }
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #b5b5b5 !important;
  }
  ::-moz-placeholder {
    color: #b5b5b5 !important;
  }

  &:focus {
    &::placeholder {
      color: transparent !important;
    }
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: transparent !important;
    }
    ::-moz-placeholder {
      color: transparent !important;
    }
  }
`;

export const NavbarMobile = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: ${navbarHeight};
`;

export const NavbarMobileItems = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    padding: 0.5rem;
  }
`;

export const NabvarIcon = styled.span`
  float: left;
  margin-top: .25rem;
  margin-right: .25rem;
  display: inline-block;
  font-size: 26px;
`;

export const NavbarProfileImg = styled.figure`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.5rem 0 0;
  height: ${navbarHeight};
  position: relative;

  img {
    height: 100%;
    padding: 1rem 0;
  }
`;

export const NavbarItem = styled.section`
  ${HelveticaFontFamily}
  font-size: 16px;
  color: #ffffff;
`;

export const PlayerButton = styled.span`
  font-size: ${(props) => props.theme.fontSize}
  margin-right: 0 auto;
`;

export const PriceButton = styled.button`
	background-color: ${(props) => props.theme.backgroundColor};
	border-radius: 8px;

	border: none;
	color: ${(props) => props.theme.color};
`;

export const HeroFrame = styled.section`
  border-radius: 5px;
	background-image: url(${props => props.theme.backgroundImage});
	background-repeat: no-repeat;
  background-size: cover;
  background-color: ${props => props.theme.backgroundColor};

  /* quick fix for signup form hero */
  &.is-fullheight {
    background: black;

    &:before {
      background-image: url(${props => props.theme.backgroundImage});
      background-repeat: no-repeat;
      background-size: cover;
      background-color: ${props => props.theme.backgroundColor};
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
    }
  }
`;

export const FrameDetails = styled.section`
  position: relative;
	padding: 12px 24px;
	font-size: 24px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 0.59;
	letter-spacing: -0.5px;
  text-align: left;
`;

export const FrameDetailsBackground = styled.section`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  mix-blend-mode: multiply;
  background-color: #1c1c1c;
`;

export const FrameDetailsDivider = styled.section`
  border-${props => props.theme.direction}: ${props => props.theme.borderValues};
  margin: 10px 0;
  font-size: 40px;
`;

export const FrameDetailsTitle = styled.h3`
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.5px;
  text-align: left;
  color: #ffffff;
`;
export const FrameDetailsSubTitle = styled.small`
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.88;
  letter-spacing: -0.3px;
  text-align: left;
  color: #ffffff;
`;

export const ButtonCart = styled.button`
	color: #FFF;
	border: 1px solid #FFF;
	border-radius: 20px;
	font-size: 14px;
	background: transparent;
	padding: 6px 18px;
`;

export const ScrollableMain = styled.section`
	background: #2a2f3a;
	background: -moz-linear-gradient(top, #2a2f3a 0%, #121016 100%);
	background: -webkit-linear-gradient(top, #2a2f3a 0%,#121016 100%);
	background: linear-gradient(to bottom, #2a2f3a 0%,#121016 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2a2f3a', endColorstr='#121016',GradientType=0 );
`;


const defaultTitleStyle = `
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.5px;
  text-align: left;
  color: #ffffff;
`;

export const HTitle = (heading) => {
  return styled[heading]`
    font-size: ${props => props.theme.fontSize};
    margin-top: ${props => props.theme.marginTop};
    margin-bottom: ${props => props.theme.marginBottom};
    ${defaultTitleStyle}
  `;
};

export const ImgCover = styled.img`
  object-fit: contain;
  border-radius: 5px;
  background-color: #0c0c0c;
`;

export const ImgCoverTitle = styled.h3`
  font-size: 15px !important;
  margin-bottom: 4px !important;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.3px;
  color: #ffffff;
`;

export const ImgCoverSubTitle = styled.p`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: -0.3px;
  color: #b1afaf;
`;

export const LogoSection = styled.section`
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-flow: column wrap;
`;

export const LogoImage = styled.img`
  vertical-align: middle;

  &:hover {
    filter: brightness(0) invert(1);
  }
`;

export const PrimaryButton = styled.button`
  border-radius: 17px;
  border: solid 1px #ffffff;
  background-color: transparent !important;
  color: #fff !important;

  font-family: 'Helvetica Neue Light' !important;
  font-size: 18px !important;
  line-height: 0.78 !important;
  letter-spacing: -0.4px !important;

  &:hover {
    background-color: #fea67f !important;
    color: #000 !important;
  }
`;

export const SecondaryButton = styled.button`
  background-color: transparent !important;
  color: #fff !important;

  font-family: 'Helvetica Neue Light' !important;
  font-size: 18px !important;
  line-height: 0.78 !important;
  letter-spacing: -0.4px !important;
`;

/*
  FORGOT PASSWORD ROUTE.
*/
export const H1ForgotPassword = styled.h1`
  ${HelveticaFontFamily}
  font-size: 24px;
  text-align: left;
  color: #ffffff;
  margin: 20px;
`;

export const H2ForgotPassword = styled.h2`
  ${HelveticaFontFamily}
  font-size: 18px;
  letter-spacing: -0.4px;
  text-align: left;
  color: #ffffff;
  margin: 30px;
`;
/*
  FORGOT PASSWORD ROUTE.
*/

export const ProfileLi = styled.li`
  ${HelveticaFontFamily}
  font-size: 16px;
  line-height: 0.88;
  letter-spacing: -0.3px;
  text-align: left;
  color: #ffffff !important;
  padding: 0.5rem;
`;

export const ProfileTitle = styled.h1`
  margin-top: 20px;
  font-family: 'Helvetica Neue Medium';
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #ffffff;
`;

export const ProfileLabel = styled.label`
  font-family: 'Helvetica Neue Light';
  font-size: 18px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: #9f9f9f;
  margin-bottom: 10px;
`;

export const ProfileText = styled.p`
  font-family: 'Helvetica Neue Light';
  font-size: 18px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: #ffffff;
`;

export const InputBlack = styled.input`
  ${InputBlackStyles}
`;

export const FavoriteH1 = styled.h1`
  ${HelveticaFontFamily}
  letter-spacing: normal;
  font-size: 18px;
  text-align: left;
  color: #ffffff;
  margin-bottom: 2rem;
`;

export const FilterButton = styled.button`
  border-radius: 5px !important;
  border: none !important;
  background-color: #333 !important;
  color: #fff !important;
  margin: 5px;
  height: auto !important;
  width: 92px;
  &:hover {
    background-color: #fea67f !important;
  }
`;

export const FavoriteActionButton = styled.span`
  font-size: 18px;
  padding: 0.3rem;
  cursor: pointer;

  &:before {
    color: ${ (props) => props.theme.color} !important;
  }

  &:hover {
    color: #fea67f !important;

    &:before {
      color: #fea67f !important;
    }
  }
`;

export const FavoriteImage = styled.img`
  border-radius: 5px;
`;


export const FavoritePlayButton = styled.button`
  border-radius: 9px !important;
  background-color: #252525 !important;
  color: #fafafa !important;
  border: solid 1px #fafafa !important;
  padding: 0.2em 1rem;
  margin: 1rem;
  text-transform: uppercase;
`;

export const CitTable = styled.table`
  background: transparent !important;

  td {
    vertical-align: middle !important;
  }

  tbody.is-hoverable tr:hover {
    background-color: #434446;
  }

  tbody tr {
    height: 3em;
    border-bottom: 2px solid #151515 !important;

    background: ${props => props.theme.tableRowBackgroundColor};

    .icon-play {
      display: none;
    }

    &.is-active {
      background-color: #434446;
    }

    .song-row-index,
    .album-cover-image,
    .icon-play {
      // match is-32x32 class of album art. This prevents row from jumping if only one row.
      width: 32px;
    }

    :hover,
    &.is-active {
      .album-cover-image,
      .song-row-index {
        display: none;
      }

      .icon-play {
        display: block;
        height 100%;
        font-size: 1.35rem;
      }
    }
  }

  td:first-child {
    border-top-left-radius: 9px;
    border-bottom-left-radius: 9px;
  }

  td:last-child {
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
  }

  td {
    ${HelveticaFontFamily}
    font-size: 14px;
    line-height: 1;
    letter-spacing: -0.3px;
    text-align: left;
    color: #ffffff !important;
  }

  th {
    white-space: nowrap;
    ${HelveticaFontFamily}
    opacity: 0.7;
    font-size: 12px;
    line-height: 1.17;
    letter-spacing: -0.2px;
    text-align: left;
    color: rgba(194, 194, 194, 1) !important;
    border-bottom: 1px solid #171717 !important;
  }
`;

export const AlbumH1 = styled.h1`
  ${HelveticaFontFamily}
  margin-top: 12px;
  font-size: 24px;
  letter-spacing: -0.5px;
  text-align: left;
  color: #ffffff;
`;

export const AlbumH2 = styled.h1`
  ${HelveticaFontFamily}
  font-size: 16px;
  letter-spacing: -0.3px;
  text-align: left;
  color: #ffffff;
`;

export const AlbumDivider = styled.hr`
  border: solid 1px #252628;
  margin: 0.5rem 0;
`;

export const AlbumP = styled.p`
  ${HelveticaFontFamily}
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.3px;
  text-align: left;
  color: #ffffff;
`;

export const SuggestionsTitle = styled.h3`
  font-family: 'Helvetica Neue Light';
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`;

export const ThankYouH1 = styled.h1`
  ${HelveticaFontFamily}
  font-size: 48px;
  letter-spacing: -1px;
  text-align: left;
  color: #ffffff;
`;

export const ThankYouH2 = styled.h2`
  ${HelveticaFontFamily}
  font-size: 30px;
  letter-spacing: -0.6px;
  text-align: left;
  color: #fea67f;
`;

export const AccountH1 = styled.h1`
  ${HelveticaFontFamily}
  font-size: 48px;
  line-height: 1;
  letter-spacing: -1px;
  text-align: left;
  color: #ffffff;
`;

export const AccountH2 = styled.h2`
  font-family: HelveticaNeue;
  font-size: 30px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.6px;
  text-align: left;
  color: #ffffff;
`;

export const AccountCreationH1 = styled.h1`
  ${HelveticaFontFamily}
  letter-spacing: normal;
  font-size: 18px;
  text-align: left;
  color: #ffffff;
  margin: 1rem 0;
`;


export const AccountCreationH2 = styled.h2`
  ${HelveticaFontFamily}
  font-size: 18px;
  letter-spacing: -0.4px;
  text-align: left;
  color: #ffffff;
  margin: 1rem 0;
`;

export const LoginH1 = styled.h1`
  ${HelveticaFontFamily}
  font-size: 24px;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  margin: 1.5rem auto;
`;

export const OrderSummaryH1 = styled.h1`
  ${HelveticaFontFamily}
  font-size: 36px;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`;

export const OrderSummaryH2 = styled.h2`
  ${HelveticaFontFamily}
  font-size: 18px;
  letter-spacing: -0.4px;
  text-align: left;
  color: #ffffff;
  margin: 20px 0;
`;

export const OrderSummaryH3 = styled.h3`
  ${HelveticaFontFamily}
  font-size: 18px;
  line-height: 0.78;
  letter-spacing: -0.4px;
  text-align: left;
  color: #ffffff;
  margin: 20px 0;
`;

export const VerticalForm = styled.section`
  column-count: 1;
  margin: 1rem 0;


  .field, .user-info {
    display: inline-block;
    width: 100%;
    word-break: break-all;
  }

  @media (min-width:961px) {
    column-count: 2;
    width: 100%;
  }
`;

export const ProfileHeroFooter = styled.section`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  bottom: -4rem;
`;

export const PlayerWrapper = styled.section`
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
`;

export const PlayerVolumeWrapper = styled.section`
  display: flex;
  align-tems: center;
  justify-content: flex-end;
`;

export const SongOrderInfoWrapper = styled.section`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
`;

export const OrderHistoryH1 = styled.h1`
  font-size: 36px;
  ${HelveticaFontFamily}
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;

  @media (min-width:961px) {
    font-size: 36px;
    text-align: center;
  }
`;

export const OrderHistoryH2 = styled.h2`
  ${HelveticaFontFamily}
  font-size: 18px;
  line-height: 0.78;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  margin: 1rem 0;

`;

export const OrderHistoryText = styled.p`
  font-family: HelveticaNeue;
  font-size: ${(props) => props.theme.fontSize};
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: -0.8px;
  text-align: left;
  color: #ffffff;
`;

export const OrderTH = styled.th`
  opacity: 0.7;
  font-size: 12px;
  ${HelveticaFontFamily}
  font-stretch: normal;
  line-height: 1.17;
  letter-spacing: -0.6px;
`;
export const SearchDropdown = styled.section`
  position: absolute;
  height: ${ (props) => props.theme.height};
  visibility: ${ (props) => props.theme.visibility};
  background: #000;
  overflow-y: scroll;

  width: 100%;
  z-index: 1;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar {
    width: 4px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fea67f;
  }

  p {
    ${HelveticaFontFamily}
    font-size: 12px;
    letter-spacing: -0.4px;
    text-align: left;
    color: #ffffff;
  }

  @media (min-width: 961px) {
    p {
      font-size: 18px;
    }
  }
`;

export const PlayerContainer = styled.section`
  justify-content: space-around !important;
  @media (max-width: 768px) {
    flex-direction: row-reverse;
  }
`;

export const PlayerInfo = styled.section`
  // display: flex;
  // justify-content: center;
  // align-content: center;
  align-items: center;
`;

export const PlayerTextWrapper = styled.section`
  vertical-align: middle;

  @media (max-width:960px) {
    margin-top: 1rem;
  }
`;


export const PlayerText = styled.p`
  ${HelveticaFontFamily}

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30ch;
  font-size: ${props => props.theme.fontSize || '14px'};
  letter-spacing: normal;
  color: #ffffff;
`;

export const CarouselWrapper = styled.section`
.slick-slider {

  .hero.is-bold {
    background-size: 100% auto;
    background-position: bottom;

    @media (max-width:768px) {
      // ensure the image doesn't get too short and not show anything.
      min-height: 30vw;
    }
  }

  .hero-foot {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  margin-top: 1rem;

  // this is an empty element that's messing up the sizing.
  .hero-head {
    display: none;
  }

  .slick-next, .slick-prev {
    height: 40px;
    background-color: #000000;
    top: 40%;
    z-index: 1;
    opacity: 0.8;

    @media (min-width:961px) {
      background-color: #000000;
      width: 20px;
      height: 90px;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      top: 43%;
    }
  }

  .slick-next {
    right: 0;

    &:before {
      font-family: 'icomoon';
      content: '\f054'
    }
  }

  .slick-prev {
    left: 0;

    &:before {
      font-family: 'icomoon';
      content: '\f053'
    }
  }
}
`;

export const SearchBarWrapper = styled.section`
  position: relative;
  z-index: 2;
  padding: 0;

  @media (min-width:961px) {
    padding: 0 1.5rem;
    margin-top: 1rem;
  }

  input {
    ${InputBlackStyles}
    height: 90px;

    &,
    &::placeholder {
      font-size: 1.5rem !important;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: -1.8px;
    }

    &::placeholder {
      font-family: Helvetica, 'icomoon' !important;
      text-align: ${props => props.searchPlaceholderAlign};
      opacity: 1; /* Firefox */
    }
  }
`;

export const NavbarWrapper = styled.nav`
  height: ${navbarHeight} !important;

  a {
    color: #fff;
  }

  .navbar-item {
    padding: 0 0.5em !important;

    img {
      max-height: none;
    }
  }

  .navbar-item-social {
    a {
      line-height: 1em !important;
    }
  }

  .navbar-item-img {
    font-size: 1em;
    margin-top: 0;

    :hover:before {
      color: #fea67f !important;
    }
  }

  .is-active {
    height: 100vh;

    a {
      font-size: 20px;
    }

    .navbar-item {
      padding: 1.5em 0.5em !important;
    }

    .navbar-item-social {
      display: inline-block;

      a {
        line-height: 1em !important;
      }
    }
  }

  .market-icon {
    font-size: 24px;
  }

  .heart-icon {
    font-size: 24px;
  }

  .active {
    color: #fea67f !important;

    &:before {
      color: #fea67f !important;
    }
  }

`;

export const CoverWrapper = styled.section`
  position: relative;

  figure:hover {
      img {
          opacity: 0.5;
      }
      .play-button {
          visibility: visible;
      }
  }
  .play-button {
      visibility: hidden;
      color: #fff;
      font-size: 60px;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
  }
`;

export const WaveLoader = styled.section`
  span {
    position: relative;
    border-radius: 50%;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin: 2px;
    background-color: white;
    opacity: .5;
  }

  span:first-child {
    animation: wavy-loader 2.5s .1s ease-out infinite;
  }

  span:nth-child(2) {
    animation: wavy-loader 2.5s .2s ease-out infinite;
  }

  span:nth-child(3) {
    animation: wavy-loader 2.5s .3s ease-out infinite;
  }

  span:nth-child(4) {
    animation: wavy-loader 2.5s .4s ease-out infinite;
  }

  span:nth-child(5) {
    animation: wavy-loader 2.5s .5s ease-out infinite;
  }

  @keyframes wavy-loader {
    0%    { top: 2px; }
    1%    { top: 4px; }
    2%    { top:6px; }
    3%    { top:8px; }
    4%    { top: 10px; }
    5%    { top:12px; opacity: 1; }
    6%    { top: -2px; opacity: 1; }
    7%    { top: -4px; opacity: 1; }
    8%    { top: -6px; opacity: 1; }
    9%    { top: -8px; opacity: 1; }
    10%   { top: -10px; opacity: 1; }
    11%   { top: -12px; opacity: 1; }
    12%   { top: 0; opacity: .5; }
    100%  { top: 0; opacity: .5; }
  }
`;

export const ModalLoginWrapper = styled.section`
  border-radius: 5px;
  background-image: linear-gradient(to top, #1c1c1c, #121212);
  box-shadow: 1px 1.7px 33.3px 1.8px rgba(24, 24, 24, 0.4);
`;

export const ModalLoginH2 = styled.h2`
  font-family: Helvetica;
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.5px;
  color: #ffffff;
`;

export const ModalLoginContent = styled.p`
  font-family: 'Helvetica Neue Light';
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.3px;
  text-align: left;
  color: #ffffff;
`;

export const DropdownAnchor = styled.a`
  color: #fff !important;

  &:hover {
    background-color: #fea67f !important;
  }
`;

export const FormWrapper = styled.form`
  .field {
    margin-bottom: 1rem !important;
  }
`;

export const FooterWrapper = styled.footer`
    background: #000;
    width: 100%;
    height: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TdOverflowEllipsis = styled.td`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 50vh;
`;

export const HoverLink = styled.a`
  color: white;

  &:hover {
    color: #fea67f !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/HelperComponents/StyledComponents.js